<template>
  <van-dialog v-model="dialogShow" title="" class="cert-detail" :showConfirmButton="false" :showCancelButton="false">
    <div class="main-con">
      <div class="logo"><img src="@assets/images/cert/logo.png" /></div>
      <div class="level">
        <div class="level-message-box">
          <img :src="levelImgPath" />
        </div>
      </div>
      <div class="text-box">
        <div class="block block01">
          <p class="chinese">授予</p>
          <p class="en">Presented to</p>
        </div>
        <div class="block block02">
          <p class="chinese">{{detailItem.DoctorName}} <span>医生</span></p>
          <p class="en">Dr.{{detailItem.DoctorEnName}}</p>
        </div>
        <div class="block block03">
          <img src="../../../assets/images/cert/text01.jpg" style='width:70%' />
        </div>
        <div class="block block04">
          <img src="../../../assets/images/cert/text02.jpg" style='width:80%' />
        </div>
      </div>
      <div class="footer">
        <div class="left date">
          <div class="top"><img src="../../../assets/images/cert/date-title.png" /></div>
          <div class="bottom">{{detailItem.DateFormat}}</div>
        </div>
        <div class="right sign"><img src="../../../assets/images/cert/signature.png" /></div>
      </div>
    </div>
    <div class="close-btn" @click="$emit('closeCertDialog')">
      <van-icon name="close" />
    </div>
  </van-dialog>
</template>
<script>
import vPinyin from '@utils/vue-py'
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    level: {
      type: Number,
      default: null
    }
  },
  watch: {
    show: {
      handler (newVal, oldVal) {
        this.dialogShow = newVal;
      },
      immediate: true
    }
  },
  data () {
    return {
      dialogShow: false,
      detailItem: {},
      levelImgPath: require(`@assets/images/cert/level-${this.level}.png`),
    }
  },
  created () {
    this.getCertDetail()
  },
  methods: {
    getCertDetail () {
      this.$Request({
        AppID: this.GLOBAL.AppID,
        Method: 'GetDoctorCert',
        Star: this.level,//星级 
      }).then(res => {
        this.detailItem = res || {}
        //医生英文名
        if (res.DoctorName) {
          this.detailItem.DoctorEnName = vPinyin.chineseToPinYin(res.DoctorName)
        }
        this.detailItem.DateFormat = res.DateFormat.split(' ')[0]
        console.log(this.detailItem.DateFormat, 'detailItem.DateFormat')
      })
    }
  }
}
</script>
<style lang="less" scoped>
.cert-detail {
  border-radius: 0;
  width: auto;
  height: auto;
  background: transparent;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  .main-con {
    width: 680px;
    height: 904px;
    background: url("../../../assets/images/cert/cert-bg.png") top center
      no-repeat;
    background-size: 100%;
    .logo {
      text-align: center;
      padding: 34px 0 16px 0;
      img {
        width: 212px;
        height: 68px;
      }
    }
    .level {
      position: relative;
      width: 100%;
      height: 175px;
      background: url("../../../assets/images/cert/theme-bg.png") no-repeat;
      background-size: 100%;
      .level-message-box {
        position: absolute;
        width: 180px;
        height: 200px;
        top: -15px;
        right: 0;
        img {
          max-width: 100%;
          max-height: 100%;
        }
      }
    }
    .block03 {
      .en {
        font-size: 20px;
      }
    }
    .block4 {
      .en {
        font-size: 18px;
      }
    }
    .text-box {
      .block {
        text-align: center;
        margin: 20px 0;
        word-break: break-all;
        color: #1d304f;
      }
      p.chinese {
        margin-bottom: 0;
      }
      .block01 {
        font-size: 24px;
      }
      .block02 {
        font-size: 24px;
        .chinese {
          font-size: 28px;
          span {
            font-size: 24px;
          }
        }
      }
      .block03 {
        .chinese {
          font-size: 32px;
        }
        .en {
          font-size: 22px;
        }
      }
      .block04 {
        font-size: 22px;
        transform: scale(0.9);
        word-spacing: 0em;
      }
    }
    .footer {
      position: absolute;
      width: 100%;
      bottom: 150px;
      left: 0;
      display: flex;
      justify-content: space-around;
      align-items: center;
      // margin-top: 30px;
      .left,
      .right {
        display: inline-block;
      }
      img {
        max-width: 100%;
        max-height: 100%;
      }
      .date {
        .top {
          width: 168px;
          height: 20px;
          margin-top: 20px;
        }
        .bottom {
          font-size: 20px;
          color: #1d304f;
          transform: scale(0.5);
          transform-origin: 0;
          margin-top: 10px;
          margin-left: 5px;
        }
      }
      .sign {
        width: 172px;
        height: 70px;
      }
    }
  }
  .close-btn {
    text-align: center;
    .van-icon-close::before {
      color: #ffffff;
      margin: 20px auto;
      font-size: 70px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/member/components/cert-detail.vue